import { AppStateSlice } from '$tablet-app/src/app/stores/app_state';
import { MealType } from '@akin-home/amplify';
import { RecipeSearchScreenState } from './types';

export const createRecipeSearchScreenState: AppStateSlice<
  RecipeSearchScreenState
> = (set) => ({
  recipe_search: {
    search_input: '',
    filter_dialog_visible: false,

    active_filter_ids: [],
    excluded_filter_ids: [],

    selectRecipe(recipe) {
      set((state) => {
        state.recipe_search.selected_recipe = recipe;
      });
    },

    clearSelectedRecipe() {
      set((state) => {
        delete state.recipe_search.selected_recipe;
      });
    },

    reset() {
      set((state) => {
        delete state.recipe_search.selected_recipe;
        state.recipe_search.search_input = '';
        state.recipe_search.filter_dialog_visible = false;

        /** Clear meal type filters, as these are usually set by the route params */
        state.recipe_search.active_filter_ids =
          state.recipe_search.active_filter_ids.filter(notMealTypeFilter);

        state.recipe_search.excluded_filter_ids =
          state.recipe_search.excluded_filter_ids.filter(notMealTypeFilter);
      });
    },

    setSearchInput(text) {
      set((state) => {
        state.recipe_search.search_input = text;
      });
    },

    openFilterDialog() {
      set((state) => {
        state.recipe_search.filter_dialog_visible = true;
      });
    },

    closeFilterDialog() {
      set((state) => {
        state.recipe_search.filter_dialog_visible = false;
      });
    },

    setActiveFilters(filters) {
      set((state) => {
        state.recipe_search.active_filter_ids = filters;
      });
    },

    setExcludedFilters(filters) {
      set((state) => {
        state.recipe_search.excluded_filter_ids = filters;
      });
    },

    toggleActiveFilter(id) {
      set((state) => {
        const { active_filter_ids, excluded_filter_ids } = state.recipe_search;

        if (active_filter_ids.includes(id)) {
          state.recipe_search.active_filter_ids.splice(
            active_filter_ids.indexOf(id),
            1
          );
        } else if (excluded_filter_ids.includes(id)) {
          state.recipe_search.excluded_filter_ids.splice(
            excluded_filter_ids.indexOf(id),
            1
          );
        } else {
          state.recipe_search.active_filter_ids.push(id);
        }
      });
    },
  },
});

const notMealTypeFilter = (filter_id: string) =>
  ![
    MealType.Breakfast,
    MealType.Lunch,
    MealType.Dinner,
    MealType.Snack,
  ].includes(filter_id as MealType);
